import isAlkanes from './is-alkanes'

const PREFIX = 'alkane-'

/// The /alkanes AMM page for a wallet token's collection slug
/// (`alkane-2:490` → `/alkanes/2:490`), or null when the slug is not an
/// alkane.
///
/// Alkanes trade on the AMM, so a wallet row for one belongs on the alkanes
/// market page — not the marketplace's CollectionDetail panel, which offers a
/// list/send flow against an order book these tokens barely have.
export default function alkanesPathForSlug(slug?: string | null): string | null {
	if (!slug || !isAlkanes(slug)) {
		return null
	}
	const id = slug.slice(PREFIX.length)
	// Only the canonical `block:tx` form routes; anything else stays on the
	// old panel rather than pushing the user to a 404.
	return /^\d+:\d+$/.test(id) ? `/alkanes/${id}` : null
}
